// import BookingsRoutes from "./bookings.js";
import LocationRoutes from "./locations";
// import DomainRoutes from "./domains";
import SettingsRoutes from "./settings";
import PaymentRoutes from "./payments";
// import paymentsRoutes from "./payments";
// import AnalyticRoutes from "./analytic"

export default [
  {
    path: "/enterprise/dashboard",
    name: "EnterpriseCustomerDashboard",
    component: () => import("@/views/EnterpriseCustomer/Dashboard/index.vue"),
  },
//   ...BookingsRoutes,
//   ...DomainRoutes,
  ...LocationRoutes,
  ...SettingsRoutes,
  ...PaymentRoutes
//   ...paymentsRoutes,
//   ...AnalyticRoutes
];
